<template>
  <div class="content-body">
    <component :is="curentComponents" @showOther="showOther"></component>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  /* global require */
  name: 'index',
  data() {
    return {
      curentComponents: 'PlanView',
    };
  },
  created() {

  },
  methods: {
    showOther(type) {
      const views = {
        plan: 'PlanView',
        group: 'GroupView',
        adv: 'AdvView'
      };
      if (type !== '') {
        this.curentComponents = views[type];
      }
    }
  },
  components: {
    PlanView: resolve => require(['./Components/Plan.vue'], resolve),
    GroupView: resolve => require(['./Components/Group.vue'], resolve),
    AdvView: resolve => require(['./Components/Adv.vue'], resolve)
  }
};
</script>
<style lang="less" scoped="">

</style>
